import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { bannerService } from "./services/Banner.service";
import BannerTable from "./BannerTable";
import BannerForm from "./BannerForm";
import { toast } from "react-toastify";
import ConfirmationModal from "../../Shared/ConfirmationModal";

const initialFetchingState = {
  fetching: false,
  fetched: false,
  events: null,
  error: null,
  filterParams: null,
  pages: null,
  pageNum: 0,
  pageSize: 10,
  imageUrl: null,
};

const initialSubmitState = {
  submitting: false,
  submitted: false,
  formResponse: null,
  formError: null,
  hasParams: false,
  isView: false,
};

const initailGetState = {
  fetchingEvent: false,
  fetchedEvent: false,
  fetchingError: null,
  selectedRow: null,
};

const initailDeleteState = {
  deletingEvent: false,
  deletedEvent: false,
  deleteError: null,
  deleteResponse: null,
};

class ManageBanners extends Component {
  state = {
    ...initialFetchingState,
    ...initialSubmitState,
    ...initailGetState,
    ...initailDeleteState,
    isDeleteButton: false,
  };

  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getEvents({ pageNum: pageNum + 1, pageSize });
  }

  getEvents = async params => {
    this.setState({
      ...this.state,
      fetching: true,
    });
    try {
      let response = await bannerService.getAllEvents(params);
      if (response) {
        this.setState({
          ...this.state,
          fetching: false,
          fetched: true,
          events: response,
          pages: Math.ceil(response.count / params.pageSize),
          error: null,
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        fetching: false,
        fetched: false,
        error,
      });
    }
  };

  addBanner = async requestBody => {
    const { pageSize, selectedRow } = this.state;

    this.setState({
      ...this.state,
      submitting: true,
      submitted: false,
      formResponse: null,
      formError: null,
    });
    try {
      let response = await bannerService.addBanner(
        requestBody,
        selectedRow && selectedRow.id
      );
      if (response) {
        this.setState({
          ...this.state,
          submitting: false,
          submitted: true,
          formResponse: response,
          formError: null,
        });
        this.getEvents({ pageNum: 1, pageSize });
        toast.success(`Banner Ad created successfully`, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 4000,
        });
        selectedRow && this.resetButton();
      }
    } catch (error) {
      this.setState({
        ...this.state,
        formError: error,
        submitting: false,
      });
    }
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getEvents(params);
  
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    this.setState({ filterParams: params, pageNum: 0 }, () => this.fetchData());
  };

  getEvent = async (params, action) => {
    this.setState({
      isDeleteButton: false,
      ...this.state,
      ...initialSubmitState,
      fetchingEvent: true,
      fetchingError: null,
    });
    try {
      let response = await bannerService.getEvent(params);

      if (response) {
        this.setState({
          ...this.state,
          ...initialSubmitState,
          fetchingEvent: false,
          fetchedEvent: true,
          hasParams: true,
          isView: action === "view" ? true : false,
          selectedRow: response,
          isDeleteButton: false,
          imageUrl: response.imageUrl ? response.imageUrl : null,
        });
      }
    } catch (error) {
      this.setState({
        ...this.state,
        ...initialSubmitState,
        fetchingEvent: false,
        fetchedEvent: false,
        fetchingError: error,
        selectedRow: null,
      });
    }
  };

  selectRow = (selectedRow, action) => {
    this.getEvent(selectedRow.original.id, action);
  };

  resetButton = () => {
    this.setState({
      hasParams: false,
      submitting: false,
      selectedRow: null,
      submitted: false,
      isView: false,
      isDeleteButton: true,
    });
  };

  showConfirmation = selectedRow => {
    if (this.state.showModal) {
      this.setState({
        showModal: !this.state.showModal,
      });
    } else {
      this.setState({
        selectedRow: selectedRow.original,
        showModal: !this.state.showModal,
      });
    }
  };

  deleteEvent = item => {
  

    if (item.id) {
      bannerService
        .deleteEvent(item.id)
        .then(response => {
          this.setState({
            response,
            error: null,
            submitting: false,
            deletingEvent: false,
            deletedEvent: true,
            deleteError: null,
            showModal: false,
            hasParams: false,
            selectedRow: null,
            submitted: false,
            isView: false,
            isDeleteButton: true,
          });
          this.fetchData();
          toast.success("Banner Ad deleted successfully", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000,
          });
        })
        .catch(error => this.setState({ formError: error, submitting: false }));
    }
    this.setState({
      showModal: !this.state.showModal,
    });
  };

  setImageNull = () => {
    this.setState({ imageUrl: null });
  };

  render() {
    const {
      fetching,
      fetched,
      events,
      pages,
      pageNum,
      pageSize,
      error,
      submitting,
      submitted,
      hasParams,
      selectedRow,
      formError,
      deletingEvent,
      deletedEvent,
      deleteError,
      deleteResponse,
      isView,
      imageUrl,
      fetchedEvent,
      fetchingError,
      fetchingEvent,
      isDeleteButton,
    } = this.state;

    return (
      <Row>
        <Col sm="4">
          <BannerForm
            submitting={submitting}
            error={formError}
            hasParams={hasParams}
            selectedRow={selectedRow}
            submitAction={this.addBanner}
            reset={this.resetButton}
            submitted={submitted}
            isView={isView}
            imageUrl={imageUrl}
            setImageNull={this.setImageNull}
            fetchedEvent={fetchedEvent}
            fetchingError={fetchingError}
            fetchingEvent={fetchingEvent}
            isDeleteButton={isDeleteButton}
          />
        </Col>
        <Col sm="8">
          <BannerTable
            fetching={fetching}
            fetched={fetched}
            data={events}
            pages={pages}
            page={pageNum}
            pageSize={pageSize}
            error={error}
            filterData={this.filterData}
            DeleteModal={this.DeleteModal}
            deleteCategory={this.deleteCategory}
            showModal={this.showConfirmation}
            setPageNumber={this.setPageNumber}
            setPageSize={this.setPageSize}
            selectRow={this.selectRow}
            routeChange={this.routeChange}
          />
        </Col>
        <ConfirmationModal
          isOpen={this.state.showModal}
          showModal={this.showConfirmation}
          action={this.deleteEvent}
          actionState={{
            sending: deletingEvent,
            sent: deletedEvent,
            error: deleteError,
            response: deleteResponse,
          }}
          item={selectedRow}
        />
      </Row>
    );
  }
}

export default ManageBanners;
